import React, { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Navbar from "../components/Navbar";
import Footer from "../Footer";

const VerifyEmail = () => {
  const location = useLocation();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("Verifying your email...");

  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const email = params.get("email") || "";
  const otp = params.get("otp") || "";
  const purpose = params.get("purpose") || "registration";

  useEffect(() => {
    const verify = async () => {
      if (!email || !otp || !purpose) {
        setStatus("error");
        setMessage("Invalid verification link. Please request a new OTP.");
        return;
      }

      try {
        const response = await axios.get(window.CARLOCA_API + "/auth/verify-email-link", {
          params: {
            email,
            otp,
            purpose,
          },
        });

        if (response?.data?.success) {
          setStatus("success");
          setMessage("Your email has been verified successfully.");
        } else {
          setStatus("error");
          setMessage(response?.data?.message || "Verification failed. Please request a new OTP.");
        }
      } catch (error) {
        setStatus("error");
        setMessage(error?.response?.data?.message || "Verification failed. Please request a new OTP.");
      }
    };

    verify();
  }, [email, otp, purpose]);

  return (
    <>
      <Navbar />
      <div className="cl-auth-page" style={{ paddingTop: 90 }}>
        <div className="cl-auth-card" style={{ maxWidth: 520 }}>
          <div className="text-center mb-3">
            <img src="/img/Logo_trusted_Cars.png" alt="Trusted Cars" style={{ height: 44, marginBottom: 10 }} />
          </div>

          <h5 className="cl-auth-title text-center">Email Verification</h5>
          <p className="cl-auth-subtitle text-center">{message}</p>

          {status === "loading" && <div className="text-center text-muted">Please wait...</div>}

          {status === "success" && (
            <div className="text-center mt-3">
              <Link to="/login" className="cl-btn cl-btn-primary">
                Continue to Login
              </Link>
            </div>
          )}

          {status === "error" && (
            <div className="text-center mt-3">
              <Link to="/register" className="cl-btn cl-btn-primary">
                Back to Register
              </Link>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default VerifyEmail;
